import type { ReactNode } from 'react'

import { localeCorrente } from '../../i18n/lingua'

/**
 * I mattoni dei widget della dashboard: un numero grande, un elenco a barre.
 * Forme semplici, fisse, le stesse ovunque: il dato è l'unica cosa che varia.
 */

export function NumeroGrande({
  valore, etichetta, tono = '', delta, sotto,
}: {
  valore: string | number
  etichetta: string
  tono?: '' | 'ok' | 'warn' | 'error'
  /** Variazione rispetto a un periodo: segno e testo, con «su» = peggio. */
  delta?: { testo: string; peggio: boolean } | null
  sotto?: ReactNode
}) {
  const v = typeof valore === 'number' ? valore.toLocaleString(localeCorrente()) : valore
  return (
    <div className={`numero-grande${tono ? ` numero-grande--${tono}` : ''}`}>
      <div className="numero-grande__valore">{v}</div>
      <div className="numero-grande__etichetta">{etichetta}</div>
      {delta && <div className={`numero-grande__delta numero-grande__delta--${delta.peggio ? 'su' : 'giu'}`}>{delta.testo}</div>}
      {sotto && <div className="muted eagle-piccolo">{sotto}</div>}
    </div>
  )
}

export interface RigaBarra {
  key: string
  nome: ReactNode
  sotto?: ReactNode
  valore: number
  testo: string
  tono?: 'ok' | 'warn' | 'error'
}

export function ElencoBarre({ righe, vuoto }: { righe: RigaBarra[]; vuoto: string }) {
  if (!righe.length) return <p className="muted" style={{ margin: 0 }}>{vuoto}</p>
  const massimo = Math.max(1, ...righe.map((r) => r.valore))
  return (
    <ul className="barre">
      {righe.map((r) => (
        <li key={r.key} className={`barre__riga${r.tono ? ` barre--${r.tono}` : ''}`}>
          <span className="barre__nome">{r.nome}{r.sotto && <span className="barre__sotto"> · {r.sotto}</span>}</span>
          <span className="barre__valore">{r.testo}</span>
          <span className="barre__traccia"><span className="barre__pieno" style={{ width: `${Math.max(2, (r.valore / massimo) * 100)}%` }} /></span>
        </li>
      ))}
    </ul>
  )
}
